import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AuthUser } from "../auth-user";
import { AuthService } from "../auth.service";

@Directive({
    selector: '[needsPermission]',
    standalone: false
})
@UntilDestroy()
export class NeedsPermissionDirective implements OnInit {
    private currentUser: AuthUser;
    @Input('needsPermission') permission;
    private userPermission: number;
    private lastStateVisibility: boolean = false;

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.authService.authUserChanged$
            .pipe(untilDestroyed(this))
            .subscribe(user => {
                this.currentUser = user;
                const permissionValue = this.currentUser?.claims?.find(x => x.type === this.permission.type)?.value;
                if (!this.isNullOrUndefined(permissionValue)) {
                    this.userPermission = parseInt(permissionValue as string);
                }

                this.render();
            });
    }

    private isNullOrUndefined(permissionValue: any) {
        return typeof permissionValue === 'undefined' || permissionValue === null;
    }

    private render() {
        if (this.hasPermission()) {
            if (!this.lastStateVisibility) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
            this.lastStateVisibility = true;
        } else {
            this.viewContainer.clear();
            this.lastStateVisibility = false;
        }
    }

    private hasPermission() {
        if (!this.permission || this.isNullOrUndefined(this.userPermission)) {
            return false;
        }

        return (this.userPermission & this.permission.val) === this.permission.val;
    }
}